import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { ToastService } from '@/services/toast.service';
import { AuthService } from '@/services/auth.service';

const AUTH_ENDPOINT_PATTERN = /\/v1\/auth\//;
const SESSION_RETRY_HEADER = 'X-Session-Retry';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const injector = inject(Injector);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
                const isAuthEndpoint = AUTH_ENDPOINT_PATTERN.test(req.url);
                const alreadyRetried = req.headers.has(SESSION_RETRY_HEADER);

                if (!isAuthEndpoint && !alreadyRetried) {
                    const authService = injector.get(AuthService);
                    return from(authService.restoreSession()).pipe(
                        switchMap((restored) => {
                            if (restored) {
                                const retryReq = req.clone({
                                    setHeaders: {
                                        Authorization: 'Bearer ' + authService.getToken(),
                                        [SESSION_RETRY_HEADER]: '1',
                                    },
                                });
                                return next(retryReq);
                            }

                            authService.expired();
                            injector.get(Router).navigate(['/login']);
                            return throwError(() => error);
                        }),
                    );
                }
            } else if (error.status === 403) {
                injector.get(ToastService).showWarnToast(
                    'Keine Berechtigung',
                    'Sie haben keine Berechtigung für diese Aktion.',
                    4000
                );
            }

            return throwError(() => error);
        })
    );
};
